import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { DevicesService } from '../../services/requests/devices.service';
import { PortsService } from '../../services/requests/ports.service';
import { StrategiesService } from '../../services/requests/strategies.service';
import { ModalClickOutsideService } from '../../services/modal-click-outside.service';

declare function showNotif(message: string, type?: string): void;

@Component({
  selector: 'app-ports',
  templateUrl: './ports.component.html',
  styleUrls: ['./ports.component.css']
})
export class PortsComponent implements OnInit, OnDestroy, AfterViewInit {
  devices: any[] = [];
  filteredDevices: any[] = [];
  ports: any[] = [];
  selectedDevice: any = null;
  isLoading = false;
  isModalLoading = false;
  isModalOpen = false;
  cronActivated = false;
  portsSlotsStatus: any[] = [];
  showAddDeviceModal = false;
  searchTerm: string = '';
  archiveFilter: 'active' | 'archived' | 'all' = 'active';
  archiveActionLoading: Record<string, boolean> = {};
  
  isPhoneRecoveryLoading = false;
  showPhoneNumberInput = false;
  manualPhoneNumber = '';

  allSlots: any[] = [];
  selectedDisplayMode: string = 'totalEnvoi';
  selectedDisplayModeLeft: string = 'portStatus';
  envoiMoyen: number = 0;
  envoiTotal: number = 0;
  envoiTotalJour: number = 0;
  envoiTotalHeure: number = 0;
  envoiMoyenJour: number = 0;
  envoiMoyenHeure: number = 0;
  revenuTotalGeneratedReception: number = 0;
  revenuMoyenGeneratedReception: number = 0;
  nbDeTelRecupere: number = 0;
  nbDeTelNonRecupere: number = 0;
  ratioTelRecupere: number = 0;
  coutParSms: number = 0;
  coutParSmsSansReception: number = 0;
  currentStrategy: any = null;
  editingDeviceId: string | null = null;
  editingDeviceName: string = '';
  commentEditDeviceId: string | null = null;
  commentEditValue: string = '';

  showModal = false;
  modalConfig: any = {
    title: 'Confirmation',
    confirmText: 'Confirmer',
    cancelText: 'Annuler',
    confirmButtonClass: 'modal-btn-primary',
    icon: 'warning',
    iconColor: 'blue',
    isLoading: false
  };
  pendingAction: () => void = () => {};

  device = {
    name: '',
    nbPorts: null,
    nbSlots: null,
    priorite: 1,
    idUser: '',
    configureMachine: false,
    configureWebhook: false,
    ip: '',
    identifiant: '',
    password: '',
    webhookUrl: '',
    prixAvantSwitch: null,
    prixAvantEnvoi: null,
    usedForReception: false
  };

  type: string = 's';
  general = 'o';
  testAutomatique = 'n';
  use = 'n';
  updateCheckbox = 'n';
  limiteSms: number = 0; 
  limiteMms: number = 0; 

  private cronIntervalId: any = null;
  private autoRefreshIntervalId: any = null;
  private pendingSmsIntervalId: any = null;

  @ViewChild('addDeviceModalContent', { static: false }) addDeviceModalContent!: ElementRef;

  constructor(
    private devicesService: DevicesService,
    private portsService: PortsService,
    private strategiesService: StrategiesService,
    private modalClickOutsideService: ModalClickOutsideService
  ) {}

  ngOnInit(): void {
    this.device.idUser = localStorage.getItem('idUser') || '';
    this.isLoading = true;
    
    try {
      const savedFilter = localStorage.getItem('localStorage_SP-GetDevices') as 'active' | 'archived' | 'all' | null;
      if (savedFilter === 'active' || savedFilter === 'archived' || savedFilter === 'all') {
        this.archiveFilter = savedFilter;
      }
    } catch (e) {
    }

    this.waitForCSSAndLoad();
    
    this.cronIntervalId = setInterval(() => {
      this.loadPortsSlotsStatus();
      this.loadPendingSmsCounts();
    }, 60000);

    this.startAutoRefresh();

    this.pendingSmsIntervalId = setInterval(() => {
      if (this.devices && this.devices.length > 0) {
        this.loadPendingSmsCounts();
      }
    }, 10000);
  }

  ngAfterViewInit(): void {
    this.updateModalRegistration();
  }

  private waitForCSSAndLoad(): void {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.loadDevices();
        this.loadPortsSlotsStatus();
      });
    });
  }

  private updateModalRegistration(): void {
    if (this.addDeviceModalContent) {
      if (this.showAddDeviceModal) {
        this.modalClickOutsideService.registerModal(this.addDeviceModalContent, () => this.closeAddDeviceModal());
      } else {
        this.modalClickOutsideService.unregisterModal(this.addDeviceModalContent);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.cronIntervalId) {
      clearInterval(this.cronIntervalId);
      this.cronIntervalId = null;
    }

    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
      this.autoRefreshIntervalId = null;
    }

    if (this.pendingSmsIntervalId) {
      clearInterval(this.pendingSmsIntervalId);
      this.pendingSmsIntervalId = null;
    }

    if (this.addDeviceModalContent) {
      this.modalClickOutsideService.unregisterModal(this.addDeviceModalContent);
    }

  }

  loadDevices(): void {
    this.isLoading = true;
    this.devicesService.getAll().subscribe({
      next: (response: any) => {
        setTimeout(() => this.isLoading = false, 300);
        if (response.status) {
          this.devices = (response?.data?.devices || []).map((device: any) => ({
            ...device,
            isArchive: device.isArchive !== undefined ? device.isArchive : false,
            usedForReception: device.usedForReception !== undefined ? device.usedForReception : false
          }));
          this.applyFilter();
          this.restoreDeviceSelection();
          this.loadPendingSmsCounts();
        } else {
          showNotif(response.message || '❌ Erreur lors du chargement des machines', 'error');
        }
      },
      error: (error: any) => {
        setTimeout(() => this.isLoading = false, 300);
        showNotif(error?.error?.message || '❌ Erreur serveur lors du chargement des machines', 'error');
      }
    });
  }

  loadPendingSmsCounts(): void {
    this.devices.forEach(device => {
      this.devicesService.countPendingSms(device._id).subscribe({
        next: (response: any) => {
          if (response.status) {
            device.pendingSmsCount = response.data?.count || 0;
            device.pendingSmsCountWaitingConfirmation = response.data?.countWaitingConfirmation || 0;
          } else {
            device.pendingSmsCount = 0;
            device.pendingSmsCountWaitingConfirmation = 0;
          }
        },
        error: () => {
          device.pendingSmsCount = 0;
          device.pendingSmsCountWaitingConfirmation = 0;
        }
      });
    });
  }

  relancerDeliveredForDevice(device: any): void {
    if (!device?._id || (device.pendingSmsCountWaitingConfirmation || 0) === 0) {
      showNotif('Aucun SMS \"délivré\" en attente de confirmation pour cette machine.', 'info');
      return;
    }
    
    this.modalConfig = {
      title: 'Relancer les SMS délivrés',
      message: `⚠️ Relancer les SMS délivrés mais non confirmés pour la machine <strong>"${device.name}"</strong> ?`,
      confirmText: 'Relancer',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.modalConfig.isLoading = true;
      this.devicesService.reloadDeliveredForDevice(device._id).subscribe({
        next: (response: any) => {
          this.modalConfig.isLoading = false;
          if (response.status) {
            this.showModal = false;
            showNotif(response.message || '🔄 SMS délivrés remis en pile d\'envoi pour cette machine', 'success');
            this.loadPendingSmsCounts();
          } else {
            showNotif(response.message || '❌ Erreur lors de la relance des délivrés pour cette machine', 'error');
          }
        },
        error: (error: any) => {
          this.modalConfig.isLoading = false;
          showNotif(error?.error?.message || '❌ Erreur serveur lors de la relance des délivrés pour cette machine', 'error');
        }
      });
    };
  }

  private startAutoRefresh(): void {
    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
    }

    this.autoRefreshIntervalId = setInterval(() => {
      if (!this.selectedDevice || !this.selectedDevice._id) {
        return;
      }

      this.loadAllSlots(this.selectedDevice._id, true)
        .then(() => {
          this.calculateLimitsForPorts();
          this.calculateEnvoiMoyen();
        })
        .catch(() => {});
    }, 15000);
  }

  loadPortsSlotsStatus(): void {
    this.portsService.getAllPortsSlotsStatus().subscribe({
      next: (response: any) => {
        if (response.status) {
          const result = response.data || {};
          this.cronActivated = result.cronActivated || false;
          this.portsSlotsStatus = result.data || [];
          
          if (this.selectedDevice && this.portsSlotsStatus.length) {
            const deviceCronData = this.portsSlotsStatus.find(device => 
              device.deviceId === this.selectedDevice._id.toString()
            );

            if (deviceCronData && deviceCronData.activePortsSlots) {
              this.ports.forEach(port => {
                const cronPortData = deviceCronData.activePortsSlots.find((cronPort: any) => 
                  cronPort.portNumber === port.number
                );

                if (cronPortData) {
                  port.isOpen = cronPortData.isOpen ? 'o' : 'f';
                  port.slotActuel = cronPortData.slotNumber || port.slotActuel;
                }
              });
            }
          }
        } else {
          this.cronActivated = false;
        }
      },
      error: () => {
        this.cronActivated = false;
      }
    });
  }


  updateDevicePriority(device: any, newPriority: number): void {
    const adjustedPriority = newPriority < 1 ? 1 : newPriority;

    const data = {
      idMachine: device._id,
      priorite: adjustedPriority
    };

    this.devicesService.updateConnexion(data).subscribe({
      next: (response: any) => {
        if (response.status) {
          device.priorite = adjustedPriority;
          showNotif('✅ Priorité mise à jour avec succès', 'success');
          this.loadDevices();
        } else {
          showNotif(response.message || '❌ Erreur lors de la mise à jour de la priorité', 'error');
        }
      },
      error: (error: any) => {
        showNotif('❌ Erreur serveur lors de la mise à jour de la priorité', 'error');
      }
    });
  }

  onHoursFieldChange(device: any, field: string, event: Event): void {
    device[field] = (event.target as HTMLInputElement).value;
  }

  saveAllDeviceHours(device: any, event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.updateDeviceHours(device);
  }

  updateDeviceHours(device: any): void {
    const data: any = {
      idMachine: device._id
    };

    data.heureDebut = device.heureDebut || '';
    data.heureFin = device.heureFin || '';
    data.heureDebutPause = device.heureDebutPause || '';
    data.heureFinPause = device.heureFinPause || '';

    this.devicesService.updateConnexion(data).subscribe({
      next: (response: any) => {
        if (response.status) {
          showNotif('✅ Horaires mis à jour avec succès', 'success');
        } else {
          showNotif(response.message || '❌ Erreur lors de la mise à jour des horaires', 'error');
        }
      },
      error: (error: any) => {
        showNotif('❌ Erreur serveur lors de la mise à jour des horaires', 'error');
      }
    });
  }


  toggleDeviceSelection(device: any, event: any): void {
    const isChecked = event.target.checked;
    
    if (isChecked) {
      this.onSelectDevice(device);
    } else {
      this.selectedDevice = null;
      this.ports = [];
      localStorage.removeItem('selectedDeviceId');
      this.applyFilter();
    }
  }

  onSelectDevice(device: any): void {
    this.selectedDevice = device;
    localStorage.setItem('selectedDeviceId', device._id);
    this.isLoading = true;
    this.ports = [];
    
    Promise.all([
      this.loadStrategy(device.idStrat),
      this.loadPorts(device._id, true),
      this.loadAllSlots(device._id, true)
    ]).then(() => {
      this.calculateLimitsForPorts();
      this.isLoading = false;
    }).catch(() => {
      this.isLoading = false;
    });
  }

  loadPorts(idMachine: string, skipLoading: boolean = false): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!skipLoading) this.isLoading = true;
      this.portsService.get(idMachine).subscribe({
        next: (response: any) => {
          if (!skipLoading) this.isLoading = false;
          if (response.status) {
            const portsData = response?.data && Array.isArray(response.data) ? response.data
              : response?.data?.ports && Array.isArray(response.data.ports) ? response.data.ports
              : response?.ports && Array.isArray(response.ports) ? response.ports : [];
            this.ports = portsData.sort((a: any, b: any) => a.number - b.number);
            this.prefillGeneralConfig();
            resolve();
          } else {
            showNotif(response.message || '❌ Erreur lors du chargement des ports', 'error');
            reject(new Error(response.message || 'Erreur lors du chargement des ports'));
          }
        },
        error: (error: any) => {
          if (!skipLoading) this.isLoading = false;
          showNotif(error?.error?.message || '❌ Erreur serveur lors du chargement des ports', 'error');
          reject(error);
        }
      });
    });
  }

  loadStrategy(idStrat: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!idStrat) {
        this.currentStrategy = null;
        return resolve();
      }
      this.strategiesService.getById(idStrat).subscribe({
        next: (response: any) => {
          this.currentStrategy = response.status && response.data ? response.data : null;
          resolve();
        },
        error: () => {
          this.currentStrategy = null;
          reject();
        }
      });
    });
  }

  calculateLimitsForPorts(): void {
    if (!this.currentStrategy || !this.allSlots?.length) {
      this.ports.forEach(p => {
      p.limiteSms = 0;
      p.limiteMms = 0;
    });
      return;
    }

    const isLongTerme = this.currentStrategy.typeStrategie === 'long terme';
    const quotaSMS = isLongTerme ? (this.currentStrategy.quotaJourSMS || 0) : (this.currentStrategy.quotaFixeSMS || 0);
    const quotaMMS = isLongTerme ? (this.currentStrategy.quotaJourMMS || 0) : (this.currentStrategy.quotaFixeMMS || 0);
    const typeEnvoi = this.currentStrategy.typeEnvoi;

    this.ports.forEach(port => {
      if (!port.slotActuel?.port) {
        port.limiteSms = 0;
        port.limiteMms = 0;
        return;
      }
      const slotData = this.allSlots.find(s => s.port === port.slotActuel.port);
      if (!slotData) {
        port.limiteSms = 0;
        port.limiteMms = 0;
        return;
      }

      const totalEnvoiJour = slotData.totalEnvoiJour || 0;
      const calcLimit = (quota: number) => {
        return Math.max(0, quota - totalEnvoiJour);
      };

      if (typeEnvoi === 'SMS') {
        port.limiteSms = calcLimit(quotaSMS);
        port.limiteMms = 0;
      } else if (typeEnvoi === 'MMS') {
        port.limiteSms = 0;
        port.limiteMms = calcLimit(quotaMMS);
      } else if (typeEnvoi === 'SMS & MMS') {
        if (port.type === 's') {
          port.limiteSms = calcLimit(quotaSMS);
          port.limiteMms = 0;
        } else if (port.type === 'm') {
          port.limiteSms = 0;
          port.limiteMms = calcLimit(quotaMMS);
        } else {
          port.limiteSms = 0;
          port.limiteMms = 0;
        }
      } else {
        port.limiteSms = 0;
        port.limiteMms = 0;
      }
    });
  }

  toggleDeviceStatus(device: any): void {
    const newStatus = !device.isUsed;
    this.isLoading = true;
    this.devicesService.toggleStatus({ idMachine: device._id, isUsed: newStatus }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          device.isUsed = newStatus;
          const message = newStatus ? "activée pour l'envoi" : "désactivée pour l'envoi";
          showNotif(`✅ Machine ${message}`, 'success');
        } else {
          showNotif(response.message || '❌ Erreur lors du changement d\'état', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors du changement d\'état', 'error');
      }
    });
  }

  toggleDeviceInit(device: any): void {
    const newStatus = !device.phoneNumbersInitialized;
    this.isLoading = true;
    this.devicesService.togglePhoneNumbersInitialized({ idMachine: device._id, phoneNumbersInitialized: newStatus }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          device.phoneNumbersInitialized = newStatus;
          const message = newStatus ? 'activée' : 'désactivée';
          showNotif(`✅ Initialisation des phoneNumbers ${message} pour cette machine`, 'success');
        } else {
          showNotif(response.message || '❌ Erreur lors du changement d\'état', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors du changement d\'état', 'error');
      }
    });
  }

  unlockLocks(device: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!device?.locks) return;
    
    this.modalConfig = {
      title: 'Déverrouiller les verrous',
      message: `🔓 Déverrouiller le verrou pour la machine <strong>"${device.name}"</strong> ?`,
      confirmText: 'Déverrouiller',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'lock_open',
      iconColor: 'blue',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.modalConfig.isLoading = true;
      this.devicesService.unlockAllLocks().subscribe({
        next: (response: any) => {
          this.modalConfig.isLoading = false;
          if (response.status) {
            this.devices.forEach(d => (d.locks = false));
            if (this.selectedDevice) this.selectedDevice.locks = false;
            this.showModal = false;
            showNotif('✅ Verrous déverrouillés', 'success');
          } else {
            showNotif(response.message || '❌ Impossible de déverrouiller les verrous', 'error');
          }
        },
        error: (error: any) => {
          this.modalConfig.isLoading = false;
          showNotif(error?.error?.message || '❌ Erreur serveur lors du déverrouillage', 'error');
        }
      });
    };
  }

  resetAllQuotas(): void {
    this.modalConfig = {
      title: 'Réinitialiser les quotas SMS',
      message: '⚠️ Cette action remettra à zéro les quotas SMS de tous les ports. Continuer ?',
      confirmText: 'Réinitialiser',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.modalConfig.isLoading = true;
      Promise.all(this.ports.map(p => this.portsService.resetQuotaSmsById(p._id).toPromise()))
        .then((responses: any[]) => {
          this.modalConfig.isLoading = false;
          const successCount = responses.filter(res => res.status).length;
          this.showModal = false;
          if (successCount === responses.length) {
            showNotif(`✅ ${successCount} quotas SMS remis à zéro`, 'success');
          } else {
            showNotif(`⚠️ ${successCount}/${responses.length} quotas SMS remis à zéro`, 'warning');
          }
          this.onSelectDevice(this.selectedDevice);
        })
        .catch(() => {
          this.modalConfig.isLoading = false;
          showNotif('❌ Erreur serveur lors du reset global', 'error');
        });
    };
  }

  resetAllPiles(): void {
    this.modalConfig = {
      title: 'Réinitialiser les piles',
      message: '⚠️ Cette action remettra à zéro les piles (notReallySend) de tous les ports cochés. Continuer ?',
      confirmText: 'Réinitialiser',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.ports.forEach(p => {
        if (p.updateCheckbox === 'y') {
          p.notReallySend = 0;
        }
      });
      this.showModal = false;
      showNotif('✅ Tous les champs pile ont été remis à zéro localement', 'update');
    };
  }

  toggleArchiveStatus(device: any): void {
    if (!device?._id || this.isLoading) return;
    const newState = !device.isArchive;
    this.isLoading = true;
    this.devicesService.toggleArchive({ idMachine: device._id, isArchive: newState }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          device.isArchive = newState;
          showNotif(newState ? 'Machine archivée' : 'Machine désarchivée', 'success');
          this.applyFilter();
        } else {
          showNotif(response.message || '❌ Impossible de mettre à jour l\'archive', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors du changement d\'archive', 'error');
      }
    });
  }

  toggleUsedForReception(device: any): void {
    if (!device?._id || this.isLoading) return;
    const newState = !(device.usedForReception || false);
    this.isLoading = true;
    this.devicesService.updateConnexion({ idMachine: device._id, usedForReception: newState }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          device.usedForReception = newState;
          if (this.selectedDevice?._id === device._id) this.selectedDevice.usedForReception = newState;
          showNotif(newState ? '✅ Machine activée pour la réception' : '✅ Machine désactivée pour la réception', 'success');
        } else {
          showNotif(response.message || '❌ Impossible de mettre à jour l\'état de réception', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la mise à jour', 'error');
      }
    });
  }

  startEditComment(device: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.commentEditDeviceId = device._id;
    this.commentEditValue = device.commentaire || '';
  }

  cancelEditComment(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.commentEditDeviceId = null;
    this.commentEditValue = '';
  }

  saveCommentForDevice(device: any): void {
    const commentaire = (this.commentEditValue || '').trim();
    this.isLoading = true;
    this.devicesService.updateConnexion({ idMachine: device._id, commentaire }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          device.commentaire = commentaire;
          if (this.selectedDevice?._id === device._id) this.selectedDevice.commentaire = commentaire;
          this.commentEditDeviceId = null;
          this.commentEditValue = '';
          showNotif('✅ Commentaire sauvegardé avec succès', 'success');
        } else {
          showNotif(response.message || '❌ Erreur lors de la sauvegarde du commentaire', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la sauvegarde du commentaire', 'error');
      }
    });
  }

  prefillGeneralConfig(): void {
    if (this.ports.length === 0) {
      return;
    }

    const firstPort = this.ports[0];
    this.general = firstPort.isOpen ?? 'f';
    this.type = firstPort.type ?? 's';
  }

  openAddDeviceModal(): void {
    this.resetForm();
    this.showAddDeviceModal = true;
    setTimeout(() => {
      this.updateModalRegistration();
    }, 0);
  }

  closeAddDeviceModal(): void {
    this.showAddDeviceModal = false;
    this.resetForm();
    this.updateModalRegistration();
  }

  addDevice(): void {
    const { name, nbPorts, nbSlots, idUser, priorite, configureMachine, configureWebhook, ip, identifiant, password, webhookUrl } = this.device;
    if (!name?.trim() || !nbPorts || !nbSlots) {
      showNotif('❗ Merci de remplir tous les champs obligatoires.', 'error');
      return;
    }

    const newDevice: any = {
      name: name.trim(),
      nbPorts: +(nbPorts ?? 0),
      nbSlots: +(nbSlots ?? 0),
      idUser: idUser ?? null,
      priorite: Math.max(1, priorite || 1),
      usedForReception: this.device.usedForReception || false
    };

    if (configureMachine) {
      if (ip?.trim()) newDevice.ip = ip.trim();
      if (identifiant?.trim()) newDevice.identifiant = identifiant.trim();
      if (password?.trim()) newDevice.password = password.trim();
    }

    if (configureWebhook) {
      if (webhookUrl?.trim()) newDevice.webhookUrl = webhookUrl.trim();
      if (this.device.prixAvantSwitch != null) newDevice.prixAvantSwitch = this.device.prixAvantSwitch;
      if (this.device.prixAvantEnvoi != null) newDevice.prixAvantEnvoi = this.device.prixAvantEnvoi;
    }

    this.isLoading = true;
    this.devicesService.add(newDevice).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          showNotif('✅ Machine ajoutée avec succès', 'success');
          this.closeAddDeviceModal();
          this.loadDevices();
        } else {
          showNotif(response.message || '❌ Erreur lors de la création', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la création', 'error');
      }
    });
  }



  resetForm(): void {
    Object.assign(this.device, {
      name: '',
      nbPorts: null,
      nbSlots: null,
      priorite: 1,
      configureMachine: false,
      configureWebhook: false,
      ip: '',
      identifiant: '',
      password: '',
      webhookUrl: '',
      prixAvantSwitch: null,
      prixAvantEnvoi: null,
      usedForReception: false
    });
  }

  openPopup(device: any, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isLoading = true;
    this.isModalLoading = true;
    this.selectedDisplayModeLeft = 'portStatus';
    
    this.devicesService.getById(device._id).subscribe({
      next: (response: any) => {
        if (response.status && response.data) {
          this.selectedDevice = response.data;
          if (this.selectedDevice.usedFor === 'send') {
            this.selectedDisplayMode = 'totalEnvoiHeure';
          } else if (this.selectedDevice.usedFor === 'receipt') {
            this.selectedDisplayMode = 'revenuGeneratedReception';
          } else {
            this.selectedDisplayMode = 'totalEnvoi';
          }
          
          Promise.all([
            this.loadStrategy(this.selectedDevice.idStrat),
            this.loadPorts(device._id, true),
            this.loadAllSlots(device._id, true)
          ]).then(() => {
            this.calculateEnvoiMoyen();
            this.isLoading = false;
            this.isModalLoading = false;
            this.isPhoneRecoveryLoading = false;
            
            const modalElement = document.getElementById('deviceDetailModal');
            const modal = new (window as any).bootstrap.Modal(modalElement);
            modal.show();
            this.isModalOpen = true;
            document.body.classList.add('modal-open');
            
            if (modalElement) {
              modalElement.addEventListener('hidden.bs.modal', () => {
                this.isModalOpen = false;
                document.body.classList.remove('modal-open');
              }, { once: true });
            }
          }).catch(() => {
            this.isLoading = false;
            this.isModalLoading = false;
          });
        } else {
          this.isLoading = false;
          this.isModalLoading = false;
          showNotif(response.message || "❌ Erreur lors du chargement de la machine", "error");
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.isModalLoading = false;
        showNotif(error?.error?.message || "❌ Erreur serveur lors du chargement", "error");
      }
    });
  }

  toggleField(id: string, field: 'testAutomatique' | 'use' | 'updateCheckbox'): void {
    const port = this.ports.find(p => p._id === id);
    if (port) {
      port[field] = port[field] === 'y' ? 'n' : 'y';

      if (field !== 'updateCheckbox') {
        port.updateCheckbox = 'y';
        port.modifiedByGeneral = false;
      }
    }
  }


  resetField(index: number, type: 'sms' | 'pile'): void {
    const port = this.ports[index];
    if (type === 'pile') {
      port.notReallySend = 0;
      return;
    }
    this.isLoading = true;
    this.portsService.resetQuotaSmsById(port._id).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          port.quotaSms = 0;
          showNotif(`✅ Quota SMS du port ${port.number} réinitialisé`, 'success');
        } else {
          showNotif(response.message || '❌ Échec de la remise à zéro', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la réinitialisation', 'error');
      }
    });
  }

  applyGeneralConfig(): void {
    this.ports.forEach(p => {
      p.isOpen = this.general;
      p.type = this.type;
      if (this.limiteSms > 0) p.limiteSms = this.limiteSms;
      if (this.limiteMms > 0) p.limiteMms = this.limiteMms;
      p.updateCheckbox = 'y';
      p.modifiedByGeneral = true;
    });
    this.calculateLimitsForPorts();
  }

  toggleGeneral(field: 'testAutomatique' | 'use' | 'updateCheckbox'): void {
    const newValue = this[field] === 'y' ? 'n' : 'y';
    this[field] = newValue;
    this.ports.forEach(p => {
      p[field] = newValue;
      if (field !== 'updateCheckbox') {
        p.updateCheckbox = 'y';
      }
    });
  }

  resetDevice(device: any): void {
    this.modalConfig = {
      title: 'Réinitialiser la machine',
      message: `⚠️ Remettre à zéro TOUS les slots et ports de la machine <strong>"${device.name}"</strong> ?<br><br>Cela va :<br>- Vider les phoneNumber<br>- Remettre les totaux à 0<br>- Fermer tous les ports<br>- Désactiver tous les ports`,
      confirmText: 'Réinitialiser',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-warning',
      icon: 'warning',
      iconColor: 'yellow',
      warningMessage: '<p class="font-medium mb-1">Cette action est irréversible.</p>',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.modalConfig.isLoading = true;
      this.portsService.resetDevice(device._id).subscribe({
        next: (response: any) => {
          this.modalConfig.isLoading = false;
          if (response.status) {
            this.showModal = false;
            showNotif(`🔄 Reset complet de la machine "${device.name}" effectué avec succès`, 'success');
            if (this.selectedDevice?._id === device._id) {
              this.onSelectDevice(device);
            }
          } else {
            showNotif(response.message || '❌ Erreur lors du reset', 'error');
          }
        },
        error: (error: any) => {
          this.modalConfig.isLoading = false;
          showNotif(error?.error?.message || '❌ Erreur serveur lors du reset', 'error');
        }
      });
    };
  }

  deleteDevice(device: any): void {
    this.modalConfig = {
      title: 'Supprimer la machine',
      message: `⚠️ Supprimer la machine <strong>"${device.name}"</strong> ainsi que tous ses ports et slots ?`,
      confirmText: 'Supprimer',
      cancelText: 'Annuler',
      confirmButtonClass: 'modal-btn-delete',
      icon: 'warning',
      iconColor: 'red',
      warningMessage: '<p class="font-medium mb-1">Cette action est irréversible.</p>',
      isLoading: false
    };
    this.showModal = true;
    this.pendingAction = () => {
      this.modalConfig.isLoading = true;
      this.devicesService.delete(device._id).subscribe({
        next: (response: any) => {
          this.modalConfig.isLoading = false;
          if (response.status) {
            this.devices = this.devices.filter(d => d._id !== device._id);
            if (this.selectedDevice?._id === device._id) {
              this.selectedDevice = null;
              this.ports = [];
              localStorage.removeItem('selectedDeviceId');
            }
            this.showModal = false;
            showNotif('🗑️ Machine supprimée avec ses ports et slots', 'delete');
          } else {
            showNotif(response.message || '❌ Erreur lors de la suppression', 'error');
          }
        },
        error: (error: any) => {
          this.modalConfig.isLoading = false;
          showNotif(error?.error?.message || '❌ Erreur serveur lors de la suppression', 'error');
        }
      });
    };
  }

  startEditingDeviceName(device: any, event: Event): void {
    event.stopPropagation();
    this.editingDeviceId = device._id;
    this.editingDeviceName = device.name;
  }

  cancelEditingDeviceName(): void {
    this.editingDeviceId = null;
    this.editingDeviceName = '';
  }

  saveDeviceName(device: any): void {
    const newName = this.editingDeviceName.trim();
    if (!newName) {
      showNotif('❌ Le nom ne peut pas être vide', 'error');
      return;
    }
    if (newName === device.name) {
      this.cancelEditingDeviceName();
      return;
    }
    this.devicesService.updateName({ idMachine: device._id, name: newName }).subscribe({
      next: (response: any) => {
        if (response.status) {
          device.name = newName;
          if (this.selectedDevice?._id === device._id) this.selectedDevice.name = newName;
          showNotif('✅ Nom de la machine mis à jour avec succès', 'success');
          this.cancelEditingDeviceName();
        } else {
          showNotif(response.message || '❌ Erreur lors de la mise à jour du nom', 'error');
        }
      },
      error: (error: any) => {
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la mise à jour du nom', 'error');
      }
    });
  }


  update(): void {
    if (this.isLoading) {
      return;
    }
    const updatedPorts = this.ports.filter(p => p.updateCheckbox === 'y');
    if (updatedPorts.length === 0) {
      showNotif('❗ Aucune modification à enregistrer.', 'info');
      return;
    }
    this.isLoading = true;
    this.portsService.update({ ports: updatedPorts }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.status) {
          showNotif('✅ Ports mis à jour avec succès', 'success');
          if (this.selectedDevice) {
            this.isLoading = true;
            Promise.all([
              this.loadPorts(this.selectedDevice._id, true),
              this.loadAllSlots(this.selectedDevice._id, true)
            ]).then(() => {
              this.calculateLimitsForPorts();
              this.isLoading = false;
            }).catch(() => { this.isLoading = false; });
          }
        } else {
          showNotif(response.message || '❌ Erreur lors de la mise à jour', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la mise à jour', 'error');
      }
    });
  }

  markAsUpdated(id: string, fieldChanged?: string): void {
    const port = this.ports.find(p => p._id === id);
    if (port) {
      port.updateCheckbox = 'y';
      port.modifiedByGeneral = false;
      if (fieldChanged === 'type') {
        this.calculateLimitsForPorts();
      }
    }
  }



  getPortBlocks(): any[] {
    if (!this.selectedDevice?.nbPorts) return [];
    const blocks = [];
    for (let i = 0; i < this.selectedDevice.nbPorts; i += 8) {
      const start = i + 1;
      const end = Math.min(i + 8, this.selectedDevice.nbPorts);
      blocks.push({
        start,
        end,
        ports: Array.from({ length: end - start + 1 }, (_, j) => start + j)
      });
    }
    return blocks;
  }

  getSlotNumbers(): string[] {
    if (this.allSlots?.length) {
      const slotSet = new Set<string>();
      this.allSlots.forEach((slot: any) => {
        if (slot?.port?.includes('.')) {
          const slotPart = slot.port.split('.')[1];
          if (slotPart) slotSet.add(slotPart);
        }
      });
      return Array.from(slotSet).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    }
    if (!this.selectedDevice?.nbSlots) return [];
    return Array.from({ length: this.selectedDevice.nbSlots }, (_, i) => String(i + 1).padStart(2, '0'));
  }

  getPortSlotClass(port: number, slot: string): string {
    const slotData = this.allSlots.find(s => s.port === `${port}.${slot}`);
    return `port-slot-cell port-slot-${slotData?.isClosed ? 'closed' : 'open'}`;
  }

  getPhoneNumberClass(port: number, slot: string): string {
    const portData = this.ports.find(p => p.number === port);
    if (!portData?.slotActuel) return 'port-slot-cell port-slot-closed';
    const slotActuelNumber = (portData.slotActuel.port || '').split('.')[1] || '';
    const hasPhone = slotActuelNumber === slot && portData.slotActuel.phoneNumber && 
                     portData.slotActuel.phoneNumber.trim() !== '' && portData.slotActuel.phoneNumber !== '-1';
    return `port-slot-cell port-slot-${hasPhone ? 'open' : 'closed'}`;
  }

  togglePortSlot(port: number, slot: string): void {
    const portData = this.ports.find(p => p.number === port);
    if (!portData?.slotActuel) return;
    const slotActuelNumber = (portData.slotActuel.port || '').split('.')[1] || '';
    if (slotActuelNumber === slot) {
      portData.isOpen = portData.isOpen === 'o' ? 'f' : 'o';
      this.markAsUpdated(portData._id);
    }
  }

  applyFilter(): void {
    const term = this.searchTerm.toLowerCase().trim();
    const filteredByArchive = this.devices.filter(device => {
      const isArchived = !!device.isArchive;
      if (this.archiveFilter === 'active') {
        return !isArchived;
      }
      if (this.archiveFilter === 'archived') {
        return isArchived;
      }
      return true;
    });

    if (!term) {
      this.filteredDevices = [...filteredByArchive];
    } else {
      this.filteredDevices = filteredByArchive.filter(device =>
        device.name?.toLowerCase().includes(term)
      );
    }
  }

  getFilteredDevicesCount(): number {
    return this.filteredDevices.length;
  }

  setArchiveFilter(filter: 'active' | 'archived' | 'all'): void {
    if (this.archiveFilter !== filter) {
      this.archiveFilter = filter;
      this.applyFilter();
      try {
        localStorage.setItem('localStorage_SP-GetDevices', filter);
      } catch (e) {
      }
    }
  }

  getArchiveCount(type: 'active' | 'archived' | 'all'): number {
    const term = this.searchTerm.toLowerCase().trim();
    
    return this.devices.filter(device => {
      if (type !== 'all') {
        const isArchived = !!device.isArchive;
        const matchesArchive = type === 'active' ? !isArchived : isArchived;
        if (!matchesArchive) return false;
      }
      
      if (term) {
        return device.name?.toLowerCase().includes(term);
      }
      
      return true;
    }).length;
  }


  restoreDeviceSelection(): void {
    const savedDeviceId = localStorage.getItem('selectedDeviceId');
    if (savedDeviceId) {
      const device = this.devices.find(d => d._id === savedDeviceId);
      if (device) {
        this.onSelectDevice(device);
        return;
      } else {
        localStorage.removeItem('selectedDeviceId');
      }
    }
    
    if (this.filteredDevices && this.filteredDevices.length > 0) {
      this.onSelectDevice(this.filteredDevices[0]);
    }
  }


  openDeviceUrl(device: any): void {
    if (!device.ip) {
      showNotif('❌ Aucune URL configurée pour cette machine', 'error');
      return;
    }

    let url = device.ip;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'http://' + url;
    }

    window.open(url, '_blank');
    showNotif(`🌐 Ouverture de l'interface de ${device.name}`, 'info');
  }

  isWithinHoursInterval(heureDebut: string, heureFin: string): boolean {
    if (!heureDebut || !heureFin || heureDebut === '--:--' || heureFin === '--:--') {
      return false;
    }

    try {
      const now = new Date();
      const currentTime = now.getHours() * 60 + now.getMinutes();

      const [debutHours, debutMinutes] = heureDebut.split(':').map(Number);
      const [finHours, finMinutes] = heureFin.split(':').map(Number);

      const debutTime = debutHours * 60 + debutMinutes;
      const finTime = finHours * 60 + finMinutes;

      if (finTime < debutTime) {
        return currentTime >= debutTime || currentTime <= finTime;
      } else {
        return currentTime >= debutTime && currentTime <= finTime;
      }
    } catch (error) {
      return false;
    }
  }


  exportDevicePhoneNumbers(device: any): void {
    if (!device?._id) {
      showNotif('❌ Erreur: ID du device manquant', 'error');
      return;
    }

    this.isLoading = true;

    this.portsService.get(device._id).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        
        if (response.status && response.data) {
          this.generateAndDownloadCSVFromPorts(device, response.data);
          showNotif(`📊 Export CSV généré pour ${device.name}`, 'success');
        } else {
          showNotif(response.message || '❌ Aucun port trouvé pour ce device', 'error');
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        showNotif('❌ Erreur serveur lors de la récupération des slots', 'error');
      }
    });
  }

  generateAndDownloadCSVFromPorts(device: any, ports: any[]): void {
    const nbPorts = device.nbPorts || 64;
    const nbSlots = device.nbSlots || 8;
    const headers = ['X', ...Array.from({ length: nbSlots }, (_, i) => `.${String(i + 1).padStart(2, '0')}`)];
    const portsByNumber: { [key: string]: any } = {};
    ports.forEach(p => {
      if (p.number) {
        portsByNumber[p.number.toString()] = p;
      }
    });
    
    const csvLines = [headers.join(',')];
    for (let portNum = 1; portNum <= nbPorts; portNum++) {
      const port = portsByNumber[portNum.toString()];
      const row = [portNum.toString()];
      for (let slot = 1; slot <= nbSlots; slot++) {
        const slotKey = String(slot).padStart(2, '0');
        let phoneNumber = '';
        if (port?.slotActuel) {
          const slotActuelSlot = port.slotActuel.port.split('.')[1];
          if (slotActuelSlot === slotKey && port.slotActuel.phoneNumber?.trim() && port.slotActuel.phoneNumber !== '-1') {
            phoneNumber = port.slotActuel.phoneNumber.replace(/^0/, '33');
          }
        }
        row.push(phoneNumber);
      }
      csvLines.push(row.join(','));
    }
    
    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      link.href = URL.createObjectURL(blob);
      link.download = `phoneNumbers_${device.name.replace(/[^a-zA-Z0-9]/g, '_')}.csv`;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }


  formatHours(time: string): string {
    if (!time || time === '--:--') {
      return '--h--';
    }
    return time.replace(':', 'h');
  }

  normalizeTimeForInput(time: string | undefined | null): string {
    if (!time || time === '--:--' || time.trim() === '') {
      return '';
    }
    return time.trim();
  }

  copyToClipboard(text: string, event: Event): void {
    event.stopPropagation();
    this.copyTextToClipboard(text, '📋 ID copié dans le presse-papiers');
  }

  selectDeviceAndCheckRecovery(device: any): void {
    this.onSelectDevice(device);
    this.checkPhoneNumberRecoveryStatus();
  }

  checkPhoneNumberRecoveryStatus(): void {
    if (!this.selectedDevice) {
      showNotif('❌ Veuillez sélectionner une machine', 'error');
      return;
    }
    this.isPhoneRecoveryLoading = true;
    const slot101 = this.ports.find(p => p.slotActuel?.port === '1.01');
    const hasTemoinNumber = slot101?.slotActuel?.phoneNumber?.trim() && slot101.slotActuel.phoneNumber !== '-1';
    if (!hasTemoinNumber) {
      this.showPhoneNumberInput = true;
      this.isPhoneRecoveryLoading = false;
      this.openPhoneNumberModal();
      showNotif('📱 Veuillez saisir un numéro témoin pour démarrer la récupération', 'info');
    } else {
      this.executePhoneNumberRecovery();
    }
  }

  executePhoneNumberRecovery(manualNumber?: string): void {
    if (!this.selectedDevice) {
      showNotif('❌ Veuillez sélectionner une machine', 'error');
      return;
    }
    if (manualNumber && !this.isValidPhoneNumber(manualNumber)) {
      showNotif('❌ Format de numéro invalide. Utilisez +33XXXXXXXXX ou 0XXXXXXXXX', 'error');
      return;
    }
    this.isPhoneRecoveryLoading = true;
    const payload: any = { idMachine: this.selectedDevice._id };
    if (manualNumber) payload.firstPhone = manualNumber;

    this.portsService.executePhoneNumberRecovery(payload).subscribe({
      next: (response: any) => {
        this.isPhoneRecoveryLoading = false;
        this.showPhoneNumberInput = false;
        this.manualPhoneNumber = '';
        this.closePhoneNumberModal();

        if (response.status === 'success') {
          const data = response.data;
          if (data.action === 'temoin_assigned') {
            showNotif(`✅ Numéro témoin ${manualNumber} assigné au slot 1.01`, 'success');
          } else if (data.action === 'sms_sent') {
            showNotif(`✅ SMS envoyés pour le slot ${data.processedSlot}: ${data.smsResults.successCount}/${data.smsResults.totalSent} réussis`, 'success');
          }
          setTimeout(() => { if (this.selectedDevice) this.loadPorts(this.selectedDevice._id); }, 2000);
        } else {
          showNotif(response.message || '❌ Erreur lors de la récupération des numéros', 'error');
        }
      },
      error: (error: any) => {
        this.isPhoneRecoveryLoading = false;
        this.showPhoneNumberInput = false;
        this.closePhoneNumberModal();
        showNotif(error?.error?.message || '❌ Erreur serveur lors de la récupération', 'error');
      }
    });
  }

  confirmManualPhoneNumber(): void {
    if (!this.manualPhoneNumber?.trim()) {
      showNotif('❌ Veuillez saisir un numéro de téléphone', 'error');
      return;
    }
    this.executePhoneNumberRecovery(this.manualPhoneNumber.trim());
  }

  cancelManualPhoneNumber(): void {
    this.showPhoneNumberInput = false;
    this.manualPhoneNumber = '';
    this.isPhoneRecoveryLoading = false;
    this.closePhoneNumberModal();
  }

  private openPhoneNumberModal(): void {
    const modal = document.getElementById('phoneNumberInputModal');
    const bootstrap = (window as any).bootstrap;
    if (modal && bootstrap) new bootstrap.Modal(modal).show();
  }

  private closePhoneNumberModal(): void {
    const modal = document.getElementById('phoneNumberInputModal');
    const bootstrap = (window as any).bootstrap;
    if (modal && bootstrap) {
      const instance = bootstrap.Modal.getInstance(modal);
      if (instance) instance.hide();
    }
  }

  isValidPhoneNumber(phoneNumber: string): boolean {
    if (!phoneNumber || typeof phoneNumber !== 'string') return false;
    
    const cleaned = phoneNumber.replace(/[\s\-\(\)\.]/g, '');
    
    const patterns = [
        /^\+33[1-9]\d{8}$/, // +33XXXXXXXXX
        /^0[1-9]\d{8}$/,    // 0XXXXXXXXX
        /^33[1-9]\d{8}$/    // 33XXXXXXXXX
    ];
    
    for (const pattern of patterns) {
      if (pattern.test(cleaned)) {
        return true;
      }
    }
    return false;
  }

  loadAllSlots(idMachine: string, skipLoading: boolean = false): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.selectedDevice?.nbPorts || !this.selectedDevice?.nbSlots) {
        this.allSlots = [];
        return resolve();
      }

      const slotsMap: { [key: string]: any } = {};
      for (let port = 1; port <= this.selectedDevice.nbPorts; port++) {
        for (let slot = 1; slot <= this.selectedDevice.nbSlots; slot++) {
          const slotKey = `${port}.${String(slot).padStart(2, '0')}`;
          slotsMap[slotKey] = {
            port: slotKey, totalEnvoi: 0, totalEnvoiHeure: 0, totalEnvoiJour: 0,
            revenuGeneratedReception: 0, phoneNumber: '', isClosed: false
          };
        }
      }

      this.portsService.getSlotsByDevice(idMachine).subscribe({
        next: (response: any) => {
          if (response.status) {
            if (response.data?.length) {
              response.data.forEach((slot: any) => {
                if (slot.port && slotsMap[slot.port]) {
                  const phoneNumber = slot.phoneNumber;
                  const hasValidPhone = phoneNumber?.toString().trim() && 
                                       phoneNumber.toString().trim() !== '-1' &&
                                       phoneNumber.toString().trim() !== '0';
                  slotsMap[slot.port] = {
                    port: slot.port,
                    totalEnvoi: slot.totalEnvoi || 0,
                    totalEnvoiHeure: slot.totalEnvoiHeure || 0,
                    totalEnvoiJour: slot.totalEnvoiJour || 0,
                    revenuGeneratedReception: slot.revenuGeneratedReception || 0,
                    phoneNumber: hasValidPhone ? phoneNumber.toString().trim() : '',
                    isClosed: slot.isClosed !== undefined ? slot.isClosed : false
                  };
                }
              });
            }
            this.allSlots = Object.values(slotsMap);
            resolve();
          } else {
            showNotif(response.message || '❌ Erreur lors du chargement des slots', 'error');
            reject(new Error(response.message || 'Erreur lors du chargement des slots'));
          }
        },
        error: (error: any) => {
          showNotif(error?.error?.message || '❌ Erreur serveur lors du chargement des slots', 'error');
          reject(error);
        }
      });
    });
  }

  calculateEnvoiMoyen(): void {
    if (!this.selectedDevice || !this.selectedDevice.nbPorts || !this.selectedDevice.nbSlots) {
      Object.assign(this, {
        envoiMoyen: 0, envoiTotal: 0, envoiTotalJour: 0, envoiTotalHeure: 0,
        envoiMoyenJour: 0, envoiMoyenHeure: 0, revenuTotalGeneratedReception: 0,
        revenuMoyenGeneratedReception: 0, nbDeTelRecupere: 0, nbDeTelNonRecupere: 0,
        ratioTelRecupere: 0, coutParSms: 0, coutParSmsSansReception: 0
      });
      return;
    }

    this.envoiTotal = this.allSlots.reduce((sum, slot) => sum + (slot.totalEnvoi || 0), 0);
    this.envoiTotalJour = this.allSlots.reduce((sum, slot) => sum + (slot.totalEnvoiJour || 0), 0);
    this.envoiTotalHeure = this.allSlots.reduce((sum, slot) => sum + (slot.totalEnvoiHeure || 0), 0);
    this.revenuTotalGeneratedReception = this.allSlots.reduce((sum, slot) => sum + (slot.revenuGeneratedReception || 0), 0);
    this.nbDeTelRecupere = this.allSlots.filter(slot => {
      return slot.phoneNumber && 
             slot.phoneNumber.trim() !== '' && 
             slot.phoneNumber !== '-1' && 
             slot.phoneNumber !== '0';
    }).length;

    const totalPuces = this.selectedDevice.nbPorts * this.selectedDevice.nbSlots;
    this.nbDeTelNonRecupere = totalPuces - this.nbDeTelRecupere;
    const nbRecupere = this.nbDeTelRecupere || 0;

    this.envoiMoyen = nbRecupere > 0 ? Math.round((this.envoiTotal / nbRecupere) * 100) / 100 : 0;
    this.envoiMoyenJour = nbRecupere > 0 ? Math.round((this.envoiTotalJour / nbRecupere) * 100) / 100 : 0;
    this.envoiMoyenHeure = nbRecupere > 0 ? Math.round((this.envoiTotalHeure / nbRecupere) * 100) / 100 : 0;
    this.revenuMoyenGeneratedReception = nbRecupere > 0 ? Math.round((this.revenuTotalGeneratedReception / nbRecupere) * 100) / 100 : 0;
    
    const totalTel = this.nbDeTelRecupere + this.nbDeTelNonRecupere;
    this.ratioTelRecupere = totalTel > 0 ? Math.round((this.nbDeTelRecupere / totalTel) * 100 * 100) / 100 : 0;

    if (this.currentStrategy && this.envoiTotal > 0) {
      const prixCarte = this.currentStrategy.prixCarte || 0;
      const coutNet = (nbRecupere * prixCarte) - this.revenuTotalGeneratedReception;
      this.coutParSms = Math.round((coutNet / this.envoiTotal) * 1000000) / 1000000;
      this.coutParSmsSansReception = Math.round(((nbRecupere * prixCarte) / this.envoiTotal) * 1000000) / 1000000;
    } else {
      this.coutParSms = 0;
      this.coutParSmsSansReception = 0;
    }
  }

  getSlotValueByMode(port: number, slot: string, mode: string): string {
    if (mode === 'portStatus') return '';
    const slotData = this.allSlots.find(s => s.port === `${port}.${slot}`);
    if (!slotData) return mode === 'phoneNumber' ? '' : '0';
    switch (mode) {
      case 'phoneNumber': return slotData.phoneNumber || '';
      case 'totalEnvoi': return slotData.totalEnvoi?.toString() || '0';
      case 'totalEnvoiHeure': return slotData.totalEnvoiHeure?.toString() || '0';
      case 'totalEnvoiJour': return slotData.totalEnvoiJour?.toString() || '0';
      case 'revenuGeneratedReception': {
        const revenu = slotData.revenuGeneratedReception || 0;
        return revenu > 0 ? revenu.toFixed(2) : '0';
      }
      default: return '0';
    }
  }


  getSlotDisplayClassByMode(port: number, slot: string, mode: string): string {
    if (mode === 'portStatus') return this.getPortSlotClass(port, slot);
    if (mode === 'phoneNumber') {
      const slotData = this.allSlots.find(s => s.port === `${port}.${slot}`);
      const hasPhone = slotData?.phoneNumber && slotData.phoneNumber.trim() !== '' && slotData.phoneNumber !== '-1';
      return hasPhone ? 'port-slot-cell port-slot-phone-number' : 'port-slot-cell';
    }
    if (mode === 'totalEnvoi') {
      const slotData = this.allSlots.find(s => s.port === `${port}.${slot}`);
      return (slotData?.totalEnvoi || 0) === 0 ? 'port-slot-cell port-slot-zero-total' : 'port-slot-cell';
    }
    if (mode === 'revenuGeneratedReception') {
      const slotData = this.allSlots.find(s => s.port === `${port}.${slot}`);
      const revenu = slotData?.revenuGeneratedReception || 0;
      const seuil = this.selectedDevice?.remunerationReceptionSwitch || 0;
      if (revenu >= seuil && seuil > 0) return 'port-slot-cell port-slot-revenu-positive port-slot-revenu-target-reached';
      if (revenu > 0) return 'port-slot-cell port-slot-revenu-positive';
      return 'port-slot-cell port-slot-revenu-zero';
    }
    return this.getPhoneNumberClass(port, slot);
  }


  copyPhoneNumberToClipboard(phoneNumber: string): void {
    const texte = phoneNumber?.trim();
    if (!texte || texte === '' || texte === '-1' || texte === '0') {
      showNotif('❌ Numéro de téléphone invalide', 'error');
      return;
    }
    this.copyTextToClipboard(texte, '📋 Numéro de téléphone copié dans le presse-papiers');
  }

  private copyTextToClipboard(text: string, successMessage: string): void {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        showNotif(successMessage, 'success');
      }).catch(() => {
        this.fallbackCopyToClipboard(text, successMessage);
      });
    } else {
      this.fallbackCopyToClipboard(text, successMessage);
    }
  }

  private fallbackCopyToClipboard(text: string, successMessage: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.style.opacity = '0';
    textArea.setAttribute('readonly', '');
    document.body.appendChild(textArea);
    
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showNotif(successMessage, 'success');
      } else {
        showNotif('❌ Impossible de copier. Veuillez sélectionner manuellement.', 'error');
      }
    } catch (err) {
      showNotif('❌ Erreur lors de la copie', 'error');
    }
    
    document.body.removeChild(textArea);
  }

  shouldShowIndicator(mode: string): boolean {
    return mode === 'phoneNumber' || mode === 'portStatus';
  }

  shouldShowEnvoiStats(): boolean {
    const modes = [this.selectedDisplayMode, this.selectedDisplayModeLeft];
    return ['totalEnvoi', 'totalEnvoiHeure', 'totalEnvoiJour'].some(m => modes.includes(m));
  }

  shouldShowRevenuStats(): boolean {
    return [this.selectedDisplayMode, this.selectedDisplayModeLeft].includes('revenuGeneratedReception');
  }

  shouldShowPhoneStats(): boolean {
    return [this.selectedDisplayMode, this.selectedDisplayModeLeft].includes('phoneNumber');
  }

  shouldShowPortStatusStats(): boolean {
    return [this.selectedDisplayMode, this.selectedDisplayModeLeft].includes('portStatus');
  }

  getPortStatusCount(type: 'open' | 'closed' | 'total'): number {
    if (type === 'total') return this.allSlots.length;
    return this.allSlots.filter(slot => type === 'open' ? !slot.isClosed : slot.isClosed).length;
  }

  getPortStatusOpenRatio(): number {
    const total = this.getPortStatusCount('total');
    if (total === 0) return 0;
    const open = this.getPortStatusCount('open');
    return Math.round((open / total) * 100);
  }

  getSlotTitle(port: number, slot: string, mode: string): string {
    const title = `Port ${port} - Slot ${slot}`;
    if (mode === 'phoneNumber') {
      const phoneNumber = this.getSlotValueByMode(port, slot, mode);
      if (phoneNumber && phoneNumber.trim() !== '' && phoneNumber !== '-1' && phoneNumber !== '0') {
        return `${title} - Cliquez pour copier : ${phoneNumber}`;
      }
    }
    return title;
  }


  private handleSlotAction(port: number, slot: string, mode: string): void {
    if (mode === 'phoneNumber') {
      const phoneNumber = this.getSlotValueByMode(port, slot, mode);
      if (phoneNumber && phoneNumber.trim() !== '' && phoneNumber !== '-1' && phoneNumber !== '0') {
        this.copyPhoneNumberToClipboard(phoneNumber);
      } else {
        showNotif(`❌ Aucun numéro disponible pour Port ${port} - Slot ${slot}`, 'error');
      }
    } else if (mode === 'portStatus') {
      this.togglePortSlot(port, slot);
    }
  }

  onSlotPointerUp(port: number, slot: string, mode: string, event: PointerEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.handleSlotAction(port, slot, mode);
  }



  isSlotActuel(port: number, slot: string): boolean {
    const portData = this.ports.find(p => p.number === port);
    if (!portData?.slotActuel) return false;
    return (portData.slotActuel.port || '').split('.')[1] === slot;
  }

  getDisplayModeOptions(side: 'left' | 'right' = 'left'): Array<{value: string, label: string}> {
    const allOptions = [
      { value: 'portStatus', label: 'Statut des ports' },
      { value: 'totalEnvoi', label: 'Total envoi' },
      { value: 'totalEnvoiHeure', label: 'Total envoi / heure' },
      { value: 'totalEnvoiJour', label: 'Total envoi / jour' },
      { value: 'revenuGeneratedReception', label: 'Revenu réception' },
      { value: 'phoneNumber', label: 'Numéro de téléphone' }
    ];
    
    if (side === 'right') {
      return [
        ...allOptions.filter(opt => opt.value !== 'portStatus'),
        { value: 'portStatus', label: 'Statut des ports' }
      ];
    }
    return allOptions;
  }



  onModalConfirm(): void {
    this.pendingAction();
  }

  onModalClose(): void {
    if (!this.modalConfig.isLoading) {
      this.showModal = false;
    }
  }

}

